import type { CustomLayerInterface, CustomRenderMethodInput, Map as MapLibreMap } from "maplibre-gl";
export class ArcLayer implements CustomLayerInterface {
  id = "precyz-arcs"; type = "custom" as const; renderingMode = "2d" as const;
  private gl?: WebGLRenderingContext | WebGL2RenderingContext;
  private program?: WebGLProgram; private buffer?: WebGLBuffer;
  onAdd(_map: MapLibreMap, gl: WebGLRenderingContext | WebGL2RenderingContext) {
    this.gl=gl;
    const vertex=gl.createShader(gl.VERTEX_SHADER)!; gl.shaderSource(vertex,"attribute vec2 a; uniform mat4 u; void main(){gl_Position=u*vec4(a,0.,1.);}"); gl.compileShader(vertex);
    const fragment=gl.createShader(gl.FRAGMENT_SHADER)!; gl.shaderSource(fragment,"precision mediump float; void main(){gl_FragColor=vec4(.22,.78,1.,.85);}"); gl.compileShader(fragment);
    this.program=gl.createProgram()!; gl.attachShader(this.program,vertex); gl.attachShader(this.program,fragment); gl.linkProgram(this.program);
    this.buffer=gl.createBuffer()!; gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);
    gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([.48,.52,.55,.43,.62,.40,.70,.47]),gl.STATIC_DRAW);
  }
  render(gl: WebGLRenderingContext | WebGL2RenderingContext, options: CustomRenderMethodInput) {
    if(!this.program||!this.buffer)return;
    gl.useProgram(this.program); gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);
    const a=gl.getAttribLocation(this.program,"a"); gl.enableVertexAttribArray(a); gl.vertexAttribPointer(a,2,gl.FLOAT,false,0,0);
    gl.uniformMatrix4fv(gl.getUniformLocation(this.program,"u"),false,options.modelViewProjectionMatrix); gl.lineWidth(2); gl.drawArrays(gl.LINE_STRIP,0,4);
  }
  onRemove(){ if(this.gl&&this.program)this.gl.deleteProgram(this.program); if(this.gl&&this.buffer)this.gl.deleteBuffer(this.buffer); }
}
